export default __webpack_public_path__ + "static/media/analisisYEstrategia.3279e45b.svg";